module.exports = __webpack_public_path__ + "img/chatbot8.766da47f.svg";